export default {
      id: "edit_orchestrator-usage",
      viewBox: "0 0 25 19",
      url: __webpack_public_path__ + "img/icons.svg#edit_orchestrator",
      toString: function () {
        return this.url;
      }
    }